export default __webpack_public_path__ + "static/media/student-types.88ba7db7.png";